import { SET_EMPLOYEES } from "../actions/employeeActions";


const defaultState = {
    employees: []
}

export const employeeReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_EMPLOYEES) return { ...state, employees: data };
    return state;
}